export const API_CONFIG = {
  endpoints: {
    overview: '/reports/overview',
  },
  methods: {
    get: 'get',
  },
};

export const PERIOD_PRESETS = [
  { id: 'today', label: 'Hoje' },
  { id: 'yesterday', label: 'Ontem' },
  { id: 'last_7_days', label: 'Últimos 7 dias' },
  { id: 'this_month', label: 'Este Mês' },
  { id: 'last_month', label: 'Mês Passado' },
  { id: 'custom', label: 'Personalizado' },
];
